/**
 * @private
 */
export var ForceVariations;
(function (ForceVariations) {
    ForceVariations[ForceVariations["No"] = 0] = "No";
    ForceVariations[ForceVariations["ForceOne"] = 1] = "ForceOne";
    ForceVariations[ForceVariations["ForceMany"] = 2] = "ForceMany";
})(ForceVariations || (ForceVariations = {}));
export var Opener;
(function (Opener) {
    Opener["MediaManager"] = "media-manager";
    Opener["Playground"] = "playground";
    Opener["MediaEditorPanel"] = "media_editor_panel";
    Opener["PromoteVideoHome"] = "promote-video-home";
    Opener["Promoter"] = "promoter";
    Opener["SocialMarketing"] = "social-marketing-web";
})(Opener || (Opener = {}));
export var OpenerVersion;
(function (OpenerVersion) {
    OpenerVersion["V1"] = "v1";
    OpenerVersion["V2"] = "v2";
})(OpenerVersion || (OpenerVersion = {}));
//# sourceMappingURL=GenericInputParams.js.map